import BaseObjectDirective from './BaseObjectDirective';

/**
 * AsfTextObjectCtrl is a controller class that extends BaseObjectDirective.
 * It handles the initialization and manipulation of text objects within the application.
 */
export class AsfTextObjectCtrl extends BaseObjectDirective {
    /**
     * Constructor for AsfTextObjectCtrl.
     * @param {Object} $injector - AngularJS injector service.
     * @param {Object} $scope - AngularJS scope service.
     * @param {Object} $rootScope - AngularJS root scope service.
     * @param {Object} $signals - Signal handling service.
     * @param {Object} $interval - AngularJS interval service.
     * @param {Object} $timeout - AngularJS timeout service.
     * @param {Object} TableObjectAPIService - Service for table object API operations.
     * @param {Object} TaskDataService - Service for task data operations.
     * @param {Object} $routeParams - AngularJS route parameters.
     * @param {Object} $config - Configuration service.
     */
    constructor($injector, $scope, $rootScope, $signals, $interval, $timeout, TableObjectAPIService, TaskDataService, $routeParams, $config) {
        super($injector, $scope);
        this.$injector = $injector;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$signals = $signals;
        this.$interval = $interval;
        this.$timeout = $timeout;
        this.TableObjectAPIService = TableObjectAPIService;
        this.TaskDataService = TaskDataService;
        this.$routeParams = $routeParams;
        this.$config = $config;

        this.$scope.isTextWithInputObj = this.$scope.contentObject.getObjectType() === 'textMCQ';
        this.$scope.isTextObj = this.$scope.contentObject.getObjectType() === 'text';

        const TaskInfoService = this.$injector.get('TaskInfoService');
        const taskInfo = TaskInfoService.getTaskInfo();
        const assessmentLanguage = taskInfo.getLanguageCode();
        this.$scope.writingDirection = this.$rootScope.isJournal ? "ltr" : taskInfo.getInputLanguage().writingDirection;
        this.$scope.langISO = taskInfo.getISOInputLanguageCode();

        const isPDFMode = this.$config.isPDFMode();

        if (this.$scope.isTextWithInputObj) {
            let html = $.parseHTML(this.$scope.contentObject.getContent());
            let isUpdated = false;

            $(html).find('input').each(function() {
                if ("undefined" === typeof $(this).attr('autocomplete')) {
                    $(this).attr('autocomplete', 'off');
                    isUpdated = true;
                }
                if ("undefined" === typeof $(this).attr('autocorrect')) {
                    $(this).attr('autocorrect', 'off');
                    isUpdated = true;
                }
                if ("undefined" === typeof $(this).attr('autocapitalize')) {
                    $(this).attr('autocapitalize', 'off');
                    isUpdated = true;
                }
                if ("undefined" === typeof $(this).attr('spellcheck')) {
                    $(this).attr('spellcheck', false);
                    isUpdated = true;
                }

                if (!this.$rootScope.isJournal && isPDFMode && this.$scope.langISO === "ar_AR") {
                    this.amendArabicFontStyle(this);
                    isUpdated = true;
                }

                if (!this.$rootScope.isJournal && isPDFMode && this.$scope.langISO === "hi_HI") {
                    this.amendHindiFontStyle(this);
                    isUpdated = true;
                }
            }.bind(this));

            if (!this.$rootScope.isJournal && isPDFMode && this.$scope.langISO === "ar_AR") {
                $(html).find('select').each(function() {
                    this.amendArabicFontStyle(this);
                    isUpdated = true;
                }.bind(this));
            }

            if (!this.$rootScope.isJournal && isPDFMode && this.$scope.langISO === "ur_UR") {
                $(html).find('select').each(function() {
                    this.amendUrduFontStyle(this);
                    isUpdated = true;
                }.bind(this));
            }

            if (!this.$rootScope.isJournal && isPDFMode && this.$scope.langISO === "hi_HI") {
                $(html).find('select').each(function() {
                    this.amendHindiFontStyle(this);
                    isUpdated = true;
                }.bind(this));
            }

            if (isUpdated) {
                const htmlContent = $(html).map(function(idx) { return $($(html).get(idx)).prop('outerHTML') }).get().join('');
                this.$scope.contentObject.setContent(htmlContent);
            }
        }

        const frontendMode = !isCMS || this.$rootScope.isPreview;

        this.$scope.isStimulus = this.$scope.isTextObj;
        this.$scope.isCMS = this.$rootScope.isCMS;
        this.$scope.editMode = false;

        if (!frontendMode) {
            this.$scope.prefsMode = false;
            this.$scope.hasEditMode = true;
        }

        if ((typeof this.$scope.contentObject === 'undefined') || this.$scope.contentObject === null) {
            return;
        }

        this.$scope.objectUUID = this.$scope.contentObject.getUUID();
        this.$scope.taskuuid = this.$routeParams.taskUUID;
        const taskContext = this.TaskDataService.fetchContext();

        if (frontendMode) {
            return;
        }

        this.$scope.mediaList = this.getMediaList(taskContext);

        const parentContainer = this.$scope.$parent.containerObj;
        this.initPreferences(parentContainer);

        CKEDITOR.on('instanceReady', this.onInstanceReady.bind(this));
        this.$scope.$on('$destroy', function() {
            CKEDITOR.removeListener('instanceReady', this.onInstanceReady);
        }.bind(this));

        const _tmp = this.$scope.resetChanges;
        this.$scope.resetChanges = function() {
            _tmp();
            console.log("override # <" + this.$scope.contentObject.getUUID() + "> resetChanges()");
            const ckEditor = CKEDITOR.instances['cke-' + this.$scope.contentObject.getUUID()];

            if (typeof ckEditor !== "undefined") {
                ckEditor.setData(this.$scope.contentObject.getContent());
            }
            this.initPreferences(parentContainer);
        }.bind(this);

        window.IB.iFrameDelegates[this.$scope.objectUUID] = (function(_uuid) {
            return {
                getPreferences: function() {
                    return this.$scope.contentObject.getPreferences();
                }.bind(this),
                getMediaList: function() {
                    return this.$scope.mediaList;
                }.bind(this)
            };
        }.bind(this))(this.$scope.objectUUID);
    }

    /**
     * Applies Arabic font style to the given element.
     * @param {HTMLElement} element - The element to which the style will be applied.
     * @returns {HTMLElement} The modified element.
     */
    amendArabicFontStyle(element) {
        $(element).addClass("arabic-pdf-font");
        return element;
    }

    /**
     * Applies Hindi font style to the given element.
     * @param {HTMLElement} element - The element to which the style will be applied.
     * @returns {HTMLElement} The modified element.
     */
    amendHindiFontStyle(element) {
        $(element).addClass("hindi-pdf-font");
        return element;
    }

    /**
     * Applies Urdu font style to the given element.
     * @param {HTMLElement} element - The element to which the style will be applied.
     * @returns {HTMLElement} The modified element.
     */
    amendUrduFontStyle(element) {
        $(element).addClass("urdu-font-force");
        return element;
    }

    /**
     * Retrieves the list of media objects from the task context.
     * @param {Object} taskContext - The context of the task.
     * @returns {Array} List of media objects.
     */
    getMediaList(taskContext) {
        const objs = taskContext.findInstancesByType('media');
        const objList = [];

        for (const key in objs) {
            objList.push({
                uuid: key,
                name: key + '.' + objs[key].getFileExtension(),
                originalname: objs[key].getUploadName(),
                size: angular.bytesToSize(objs[key].getFileSize()),
                bytes: objs[key].getFileSize(),
                type: objs[key].getFileType(),
                mimetype: objs[key].getMimeType(),
                path: objs[key].getExtendedMediaURL(this.$scope.taskuuid) + '?' + Math.floor(Math.random() * 1000000000001),
                thumbnail: objs[key].getThumbnailURL(this.$scope.taskuuid) + '?' + Math.floor(Math.random() * 1000000000001),
                comments: objs[key].getComments(),
                height: objs[key].getHeight(),
                width: objs[key].getWidth()
            });
        }
        return objList;
    }

    /**
     * Initializes the preferences for the content object.
     * @param {Object} parentContainer - The parent container object.
     */
    initPreferences(parentContainer) {
        const includedInPDF = this.$scope.contentObject.getPreferences().includedInPDF;
        const targetHintObject = (typeof this.$scope.contentObject.getPreferences() !== "undefined" ? this.$scope.contentObject.getPreferences().targetHintObject : undefined);

        const defaultForIncludedInPDF = this.$scope.isTextWithInputObj ? true : false;

        this.$scope.preferencesValues = {};
        this.$scope.preferencesValues['includedInPDF'] = typeof includedInPDF !== 'undefined' ? includedInPDF : defaultForIncludedInPDF;
        this.$scope.preferencesValues['targetHintObject'] = targetHintObject;

        this.$scope.preferences = [
            {
                'includedInPDF': [
                    { 'type': 'checkbox', 'name': 'Included in Response PDF', 'valueKey': 'includedInPDF' }
                ],
                'targetHintObject': [{
                    'type': 'select-other-content-object',
                    'name': ' link this Object as Hint',
                    'valueKey': 'targetHintObject',
                    'objectType': 'hint',
                    'parentContainer': parentContainer
                }]
            },
        ];

        this.$scope.$watch('preferencesValues', function(val1, val2) {
            if (val1 == val2)
                return;
            const preferences = {};
            angular.forEach(this.$scope.preferencesValues, function(value, key) {
                preferences[key] = value;
            });
            const cke = CKEDITOR.instances['cke-' + this.$scope.contentObject.getUUID()];
            if (angular.isDefined(cke) && angular.isDefined(cke.changePreferences) && angular.isFunction(cke.changePreferences)) {
                cke.changePreferences(preferences);
            }
            this.$scope.contentObject.setPreferences(preferences);
        }.bind(this), true);
    }

    /**
     * Handles the CKEditor instance ready event.
     * @param {Object} e - The event object.
     */
    onInstanceReady(e) {
        if (e.editor.name === "cke-" + this.$scope.contentObject.getUUID()) {
            this.$timeout(function() {
                if (!angular.isDefined(this.$scope.contentObject)) {
                    console.warn("undefined contentobject in ckeditor data, not setting", this.$scope.contentObject.getUUID());
                    return;
                }
                if (!angular.isDefined(this.$scope.contentObject.getContent())) {
                    console.warn("undefined content in ckeditor data, not setting", this.$scope.contentObject.getUUID());
                    return;
                }

                e.editor.setData(this.$scope.contentObject.getContent());

            }.bind(this), 500);
        }
    }

    /**
     * Handles the editor callback event.
     * @param {Object} e - The event object.
     */
    onEditorCallback(e) {
        if (this.$scope.editMode) {
            this.$scope.contentObject.setContent(e.value);
        }
    }
}

/**
 * Registers the asfTextObject directive.
 * @param {Object} module - The AngularJS module.
 */
export function registerAsfTextObjectDirective(module) {
    module.directive('asfTextObject', function($compile, $bridges, $config, TaskDataService, $rootScope, $interval, $http, $signals) {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                "contentObject": "="
            },
            templateUrl: isCMS ? "/views/ib/contentobjects/textCMS.html" : "/views/ib/contentobjects/text.html",
            controller: AsfTextObjectCtrl
        };
    });
    registerContentObject(module);
}

/**
 * Registers the asfTextmcqObject directive.
 * @param {Object} module - The AngularJS module.
 */
export function registerAsfTextmcqObjectDirective(module) {
    module.directive('asfTextmcqObject', function($compile, $bridges, $config, TaskDataService, $rootScope, $interval, $http, $signals) {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                "contentObject": "="
            },
            templateUrl: isCMS ? "/views/ib/contentobjects/textCMS.html" : "/views/ib/contentobjects/text.html",
            controller: AsfTextObjectCtrl
        };
    });
}

/**
 * Registers the content object.
 * @param {Object} module - The AngularJS module.
 */
export function registerContentObject(module) {
    module.run(['ContentObjectRegistryService', function(ContentObjectRegistryService) {
        const objText = [{
            "uuid": "",
            "content": "",
            "objectType": "text",
            "type": "contentObject",
            "entity_content": {
                "content": "",
                "preferences": {}
            },
            "preferences": {
                "includedInPDF": false
            }
        }];
        const objPropertiesText = {
            type: "text",
            label: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.TEXT.LABEL',
            cssClass: "new-text-object",
            icon: "cms/icon-text-object.png",
            description: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.TEXT.DESCRIPTION',
            group: {
                id: 1
            }
        };
        ContentObjectRegistryService.register(objText, objPropertiesText);

        const objTextMCQ = [{
            "uuid": "",
            "content": "",
            "objectType": "textMCQ",
            "type": "contentObject",
            "entity_content": {
                "content": "",
                "preferences": {}
            },
            "preferences": {
                "includedInPDF": true
            }
        }];
        const objPropertiesTextMCQ = {
            type: "textMCQ",
            label: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.TEXT-MCQ.LABEL',
            cssClass: "new-text-mcq-object",
            icon: "cms/icon-text-mcq-object.png",
            description: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.TEXT-MCQ.DESCRIPTION',
            group: {
                id: 1
            }
        };
        ContentObjectRegistryService.register(objTextMCQ, objPropertiesTextMCQ);
    }]);
}